import { graphql, useStaticQuery } from "gatsby";
import { CurrentYearQuery } from "../../graphql-types";

export default function useCurrentYear() {
  const { home } = useStaticQuery<CurrentYearQuery>(graphql`
    query CurrentYear {
      home {
        currentYear
      }
    }
  `);

  return home?.currentYear;
}
